import React, { FC } from 'react';

import { useIsMobile } from '../../hooks';

import styles from './Leaderboard.module.scss';

type Props = {};

const SkeletonLoaderRow: FC<Props> = (props: Props): JSX.Element => {
  const isMobile = useIsMobile();

  return (
    <tr className={styles.loadingRow}>
      <td>
        <div className={styles.loader} style={{ width: isMobile ? 80 : 40 }} />
      </td>
      <td>
        <div className={styles.loader} style={{ width: isMobile ? 80 : 100 }} />
      </td>
      <td>
        <div className={styles.loader} style={{ width: isMobile ? 80 : 80 }} />
      </td>
      <td>
        <div className={styles.loader} style={{ width: isMobile ? 80 : 60 }} />
      </td>
      <td>
        <div className={styles.loader} style={{ width: isMobile ? 80 : 80 }} />
      </td>
    </tr>
  );
};

export default SkeletonLoaderRow;
